module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "MenuItem"
    }
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": _vm.to ? _vm.to : '',
      "active-class": "active"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.refreshPage(_vm.to)
      }
    }
  }, [_c('img', {
    staticClass: "menu-icon",
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10f22910","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuItem.vue
// module id = 272
// module chunks = 32